import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

import { PublicSubmissionForm } from '@/features/submissions/components/public/PublicSubmissionForm';
import { SubmissionSuccess } from '@/features/submissions/components/public/SubmissionSuccess';
import { PageTransition } from '@/shared/motion';

export const Route = createFileRoute('/_public/submit')({
  component: SubmitRoute,
});

function SubmitRoute() {
  // We only need to know THAT a submission succeeded, not its id (never shown).
  const [submitted, setSubmitted] = useState(false);

  return (
    <PageTransition>
      {submitted ? (
        <SubmissionSuccess onAnother={() => setSubmitted(false)} />
      ) : (
        <PublicSubmissionForm onSuccess={() => setSubmitted(true)} />
      )}
    </PageTransition>
  );
}
